<template>
  <div class="container">
    <!-- 顶部信息区域 -->
    <div class="top-section">
      <div class="left-info">
        <div class="form-row">
          <div class="form-item">
            <label>快递单号</label>
            <a-input placeholder="快递单号" v-model="waybillNo" />
          </div>
          <div class="form-item">
            <label>承运商</label>
            <a-input placeholder="承运商" v-model="waybillNo"  disabled/>
          </div>
        </div>

        <div class="form-row">
          <div class="form-item">
            <label>包材</label>
            <div class="input-with-checkbox">
              <a-input placeholder="包材" v-model="packaging" />
              <a-checkbox v-model="lockPackaging" class="checkbox-item">锁定</a-checkbox>
              <a-checkbox v-model="scanPackaging" class="checkbox-item">扫描</a-checkbox>
            </div>
          </div>
          <div class="form-item">
            <label>货主</label>
            <a-input placeholder="货主" v-model="shipper" disabled />
          </div>
        </div>

        <div class="form-row">
          <div class="form-item">
            <label>重量</label>
            <a-input placeholder="重量" v-model="weight" />
          </div>
          <div class="form-item">
            <label>包裹号</label>
            <a-input placeholder="包裹号" v-model="packageNo" disabled/>
          </div>
        </div>

        <div class="form-row">
          <div class="form-item">
            <label>理论重量</label>
            <a-input placeholder="理论重量" v-model="theoreticalWeight" disabled />
          </div>
          <div class="form-item">
            <label>实际重量</label>
            <a-input placeholder="实际重量" v-model="actualWeight" disabled />
          </div>
        </div>
      </div>

      <div class="right-info">
        <div class="connection-status">
          <span class="status-icon">🔌</span>
          <span class="status-text">未连接</span>
          <checkbox class="scale-status">电子称</checkbox>
        </div>

        <div class="force-weigh">
          <a-checkbox v-model="forceWeigh">强制称重</a-checkbox>
        </div>

        <div class="weight-count">
          <div class="count-label">称重包裹数</div>
          <div class="count-value">{{ packageCount }}</div>
        </div>
      </div>
    </div>

    <!-- 底部表格区域 -->
    <div class="bottom-section">
      <a-tabs defaultActiveKey="scanned" @change="handleTabChange">
        <a-tab-pane key="scanned" tab="已扫描"></a-tab-pane>
        <a-tab-pane key="packaging" tab="已扫描包材"></a-tab-pane>
      </a-tabs>

      <a-table
        :columns="columns"
        :dataSource="tableData"
        bordered
        :pagination="false"
        :summary="summary"
      >
      </a-table>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // 表单数据
      waybillNo: '',
      carrier: '',
      packaging: '',
      lockPackaging: false,
      scanPackaging: false,
      shipper: '',
      weight: '',
      packageNo: '',
      theoreticalWeight: '',
      actualWeight: '',
      forceWeigh: false,
      packageCount: 0,

      // 表格数据
      tableData: [
        // 示例数据，实际可能为空
        // {
        //   id: '1',
        //   productCode: 'P001',
        //   barcode: '123456789012',
        //   productName: '商品名称1',
        //   quantity: 2,
        //   theoryWeight: 0.5
        // }
      ]
    };
  },
  computed: {
    columns() {
      return [
        {
          title: '商品编码',
          dataIndex: 'productCode',
          key: 'productCode',
        },
        {
          title: '条码',
          dataIndex: 'barcode',
          key: 'barcode',
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          key: 'productName',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
        },
        {
          title: '理论重量',
          dataIndex: 'theoryWeight',
          key: 'theoryWeight',
        },
      ];
    }
  },
  methods: {
    handleTabChange(key) {
      // 切换标签页时的处理逻辑
      console.log('切换到标签页:', key);
    },
    summary() {
      // 表格合计行
      return (
        <tfoot>
        <tr>
          <td colspan="3"></td>
          <td>0</td>
          <td>0</td>
        </tr>
        </tfoot>
      );
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
  background-color: #fff;
  height: 100%;
  box-sizing: border-box;
}

.top-section {
  display: flex;
  margin-bottom: 20px;
  gap: 20px;
}

.left-info {
  flex: 1;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
}

.form-item {
  flex: 1;
}

.form-item label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  color: #333;
}

.input-with-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
}

.checkbox-item {
  white-space: nowrap;
}

.right-info {
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
}

.status-icon {
  font-size: 16px;
}

.status-text {
  color: #f50;
}

.scale-status {
  margin-left: auto;
  padding: 2px 8px;
  background-color: #f5f5f5;
  border-radius: 10px;
  font-size: 12px;
}

.force-weigh {
  padding: 10px 0;
}

.weight-count {
  margin-top: auto;
  text-align: center;
}

.count-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.count-value {
  font-size: 36px;
  font-weight: bold;
  color: #1890ff;
}

.bottom-section {
  border-top: 1px solid #e8e8e8;
  padding-top: 15px;
}

.ant-tabs {
  margin-bottom: 15px;
}

.ant-table {
  font-size: 14px;
}

.ant-table-summary {
  background-color: #fafafa;
}
</style>
